export const iconFontAwesomeShoppingTag = (
	<i className="fa-solid fa-tag"></i>
);
